<template>
  <h3>Шаг 2. Техническое задание</h3>
  <p>
    Проверьте информацию в карточке проекта и, если согласны, согласуйте проект.
  </p>
  <div>
    <a-form class="form leader-project-form" layout="vertical">
      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item name="description" label="Краткое описание проекта">
          <a-textarea
            v-model:value="model.description"
            :rows="7"
            placeholder="Опишите суть проекта"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item
          name="customerProblem"
          label="Проблема/потребность заказчика"
        >
          <a-textarea
            v-model:value="model.customerProblem"
            :rows="7"
            placeholder="Опишите потребности заказчика"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item name="projectGoal" label="Цель проекта">
          <a-textarea
            v-model:value="model.projectGoal"
            :rows="7"
            placeholder="Опишите цель проекта"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item name="projectObjectives" label="Задачи проекта">
          <a-textarea
            v-model:value="model.projectObjectives"
            :rows="7"
            placeholder="Опишите задачи проекта"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item name="devObjects" label="Объекты разработки">
          <a-textarea
            v-model:value="model.devObjects"
            :rows="7"
            placeholder="Опишите объекты разработки"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item name="expectedContent" label="Ожидаемое содержание работ">
          <a-textarea
            v-model:value="model.expectedContent"
            :rows="7"
            placeholder="Опишите ожидаемое содержание работ"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item
          name="techRequirements"
          label="Технические требования к отдельным задачам"
        >
          <a-textarea
            v-model:value="model.techRequirements"
            :rows="7"
            placeholder="Опишите технические требования к отдельным задачам"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item name="result" label="Результат">
          <a-textarea
            v-model:value="model.result"
            :rows="7"
            placeholder="Опишите планируемый результат"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item
          name="resultRequirements"
          label="Требования к представлению и оформлению результатов работ"
        >
          <a-textarea
            v-model:value="model.resultRequirements"
            :rows="7"
            placeholder="Опишите требования к предоставлению и оформлению результатов работ"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>

      <administrator-project-form-row
        :show-available="false"
      >
        <a-form-item name="otherInfo" label="Другая необходимая информация">
          <a-textarea
            v-model:value="model.otherInfo"
            :rows="7"
            placeholder="Внести другую необходимую информацию при необходимости"
            disabled
          />
        </a-form-item>
      </administrator-project-form-row>
    </a-form>
  </div>
</template>

<script setup>
import { onMounted, reactive, watch } from 'vue';
  import AdministratorProjectFormRow from '../AdministratorProjectFormRow.vue';

  const props = defineProps({
    project: {
      type: Object,
      require: true,
    },
  });

  const model = reactive({
    description: '',
    customerProblem: '',
    projectGoal: '',
    projectObjectives: '',
    devObjects: '',
    expectedContent: '',
    techRequirements: '',
    result: '',
    resultRequirements: '',
    otherInfo: '',
  });

  onMounted(() => {
    props.project && fillModel();
  })

  watch(()=>props.project, () => {
    fillModel();
  });

  const fillModel = () => {
    try {
      model.description = props.project.description;
      model.customerProblem = props.project.customerProblem;
      model.projectGoal = props.project.projectGoal;
      model.projectObjectives = props.project.projectObjectives;
      model.devObjects = props.project.devObjects;
      model.expectedContent = props.project.expectedContent;
      model.techRequirements = props.project.techRequirements;
      model.result = props.project.result;
      model.resultRequirements = props.project.resultRequirements;
      model.otherInfo = props.project.otherInfo;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
@use './administrator-project-form.scss';
</style>
